import { COLORS } from '@/styles/tokens/colors';

/** A new line snaps to a handle when its end is within this distance, in screen pixels. */
export const CONNECTION_RADIUS = 28;

/** The user can grab the end of a selected line within this distance, in screen pixels. */
export const RECONNECT_RADIUS = 12;

/** The style of the line that the user drags from a handle. */
export const CONNECTION_LINE_STYLE = {
  stroke: COLORS.BLUE[600],
  strokeWidth: 1.5,
};
